let cachedVisaData = null;

export async function loadVisaData() {
  if (cachedVisaData) {
    return cachedVisaData;
  }

  cachedVisaData = await import(`./visaFreeCountriesJson/visaFreeCountries.json`);
  return cachedVisaData;
}

export default async function getVisaInfo(citizenship, destination) {
  const visaData = await loadVisaData();

  if (visaData.rules[citizenship] && visaData.rules[citizenship][destination]) {
    return visaData.rules[citizenship][destination];
  }
  return { visa_type: null, message: "Нет данных для выбранной комбинации" };
}

export const getCountries = async () => {
  const visaData = await loadVisaData();
  return visaData.countries || {};
};

export const getDefaultCountries = async () => {
  const visaData = await loadVisaData();

  if (visaData.countries) {
    const defaultCountries = Object.entries(visaData.countries)
      .filter(([code, data]) => data.default_country === "true")
      .reduce((acc, [code, data]) => {
        acc[code] = data;
        return acc;
      }, {});
    return defaultCountries;
  }
  return {};
};
